import Vue from 'vue'
import Vuex from 'vuex'
import registerRepository from '@/repositories/register/registerRepository'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    countryId: null,
    idInformationForm: null,
    idDocFilePathList: [],
    prevExistingIdFilePathList: [],

    poiRecordId: null,
    poiPendingRecord: null,
    poiPendingReason: '',
    poiCustomPendingReason: '',
  }
}

export default new Vuex.Store({
  state: () => getDefaultState(),
  getters: {},
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState())
    },
    setState(state, newState) {
      Object.assign(state, newState)
    },
  },
  actions: {
    setIdPendingInfo(
      { commit },
      { poiRecordId = null, poiPendingRecord = null, poiPendingReason = '', poiCustomPendingReason = '' }
    ) {
      commit('setState', { poiRecordId, poiPendingRecord, poiPendingReason, poiCustomPendingReason })
    },
    resetIdInformationForm({ commit }) {
      commit('setState', { idInformationForm: getDefaultState().idInformationForm })
    },
    setIdInformationForm({ commit }, form) {
      commit('setState', { idInformationForm: form })
    },
    async actionGetData({ commit }) {
      return new Promise(async resolve => {
        const response = await registerRepository.getData(5)
        if (!(response instanceof Error)) {
          const { firstName, middleName, lastName, nationalityId, idType, idNumber, countryId, idDocFilePathList } =
            response

          const idInformationForm = {
            ...(firstName && { firstName }),
            ...(middleName && { middleName }),
            ...(lastName && { lastName }),
            ...(nationalityId && { nationalityId }),
            ...(idType && { idType }),
            ...(idNumber && { idNumber }),
          }

          commit('setState', {
            countryId: countryId,
            idInformationForm: idInformationForm,
            idDocFilePathList: idDocFilePathList?.length > 0 ? idDocFilePathList : [],
            prevExistingIdFilePathList: idDocFilePathList?.length > 0 ? idDocFilePathList : [],
          })
        }
        resolve(response)
      })
    },
  },
})
